<div class="flex flex-col items-center justify-center p-8 text-center space-y-4">
  <div class="flex flex-col items-center space-y-3">

    <h2 class="text-2xl font-semibold text-gray-900">
      Redirigiendo...
    </h2>

    <p class="text-gray-600 text-base max-w-sm">
      Estamos preparando tu registro con
      <span class="font-medium text-primary">{{ data.provider === 'linkedin-openid' ? 'LinkedIn' : (data.provider | titlecase) }} </span>.
      Esto solo tomará unos segundos.
    </p>
  </div>

  <mat-progress-spinner diameter="50" strokeWidth="5" color="primary" mode="indeterminate">
  </mat-progress-spinner>

</div>